import { normalizeDate } from '@lib/datetime';
import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class DateTime extends Type {
    /**
     * Get default value
     * @return {Date}
     */
    static getDefault() {
        return new Date();
    }

    /**
     * Parse value
     * @param value
     * @return {DateTime}
     */
    static toValue(value) {
        if (value && ((typeof value === 'object' && value.date) || typeof value === 'string')) {
            return normalizeDate(value);
        }

        return value;
    }
}

DateTime[TYPES.TYPE] = 'datetime';
